import mixpanel from "mixpanel-browser";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import identitySelectors from "../selectors/identity";

type user = {
  address: string;
  ce_role: string;
  communications_role: string;
  crm_role: string;
  email: string;
  departmentId: number;
  firstName: string;
  lastName: string;
  isEmployee: boolean;
  super_admin: boolean;
  permits_role: string;
  title: string | null;
  username: string | null;
  phone: string | null;
  id: string;
};

// Any function requiring the agency parameter only
export const mixPanelAgencyOnly = (agency: string, name: string, points: number) => {
  try {
    // Send information to Mixpanel
    mixpanel.track(name, {
      site: agency,
    });
    mixpanel.people.increment({
      "GOGOV Points": points,
    });
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export const useMixPanelPageTracking = (pageName: string) => {
  const user: user = useSelector(identitySelectors.getUser);
  const { site } = useParams<{ site: string }>();
  const isSuperAdmin = user.super_admin ? true : false;
  const isEmployee = user.isEmployee ? true : false;

  // //general page tracking
  useEffect(() => {
    mixpanel.track("Page View", {
      "site": site,
      "page_name": pageName,
      "user_type": isEmployee ? "Employee" : "Citizen",
      "Super_Admin": isSuperAdmin,
      "GORequest Role": user.crm_role,
      "GOEnforce Role": user.ce_role,
      "GOPermits Role": user.permits_role,
      "GONotify Role": user.communications_role,
    });
  }, []);
};
